import {Component, Input} from '@angular/core';
import {ProductCarouselItemComponent} from "@spartacus/storefront";
import {GonvarriProduct} from "../../core/models/gonvarri-product.model";
import {ImageGroup, Images} from "@spartacus/core";

@Component({
  selector: 'cx-product-carousel-item',
  templateUrl: './gonvarri-product-carousel-item.component.html',
  styleUrl: './gonvarri-product-carousel-item.component.scss',
  standalone: false
})
export class GonvarriProductCarouselItemComponent extends ProductCarouselItemComponent {

  @Input() override item: GonvarriProduct = {} as GonvarriProduct;

  disableAddToCart: boolean = false;
  numberOfSheets: number = 10;
  packageWeight: number = 1000;
  largoDeseado: number = 0;
  isContract: boolean | undefined;

  getContainer(): ImageGroup {
    return (this.item.images as Images)['PRIMARY'] as ImageGroup;
  }

  passThrought(code: any): any {
    return code;
  }

  updateValues(values: number[]): void {
    this.packageWeight = values[0];
    this.numberOfSheets = values[1];
  }

  updateIsDisabled(isDisabled: boolean): void {
    this.disableAddToCart = isDisabled;
  }

}
